import React from "react";

const DateRangeFilter = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
}) => {
  return (
    <div className="d-flex align-items-end flex-wrap gap-2">
      <div>
        <label htmlFor="startDate" className="form-label fw-bold mb-0 fs-14">
          From
        </label>
        <input
          id="startDate"
          type="date"
          className="form-control form-control-sm"
          value={startDate}
          max={endDate || undefined}
          onChange={(e) => onStartDateChange(e.target.value)}
        />
      </div>
      <div>
        <label htmlFor="endDate" className="form-label fw-bold mb-0 fs-14">
          To
        </label>
        <input
          id="endDate"
          type="date"
          className="form-control form-control-sm"
          value={endDate}
          min={startDate || undefined}
          onChange={(e) => onEndDateChange(e.target.value)}
        />
      </div>
      {(startDate || endDate) && (
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onClear}
        >
          Clear dates
        </button>
      )}
    </div>
  );
};

export default DateRangeFilter;
